import React, { useState, useEffect } from 'react';
import Logo from '../Assests/Logo.png';

function TopNavbar() {
  const [shouldRotate, setShouldRotate] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setShouldRotate(true);
      const timeout = setTimeout(() => {
        setShouldRotate(false);
      }, 2000); // Rotation duration
      return () => clearTimeout(timeout);
    }, 4000); // Rotation interval

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#000000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "10px 20px",
        boxSizing: "border-box",
        flexWrap: "wrap", // Allows wrapping on small screens
      }}
    >
      <img
        src={Logo}
        alt="Sparkle Car Wash Logo"
        style={{
          maxHeight: "80px",
          maxWidth: "200px",
          objectFit: "contain",
          marginBottom: "5px", // spacing for mobile wrap
        }}
      />
      <h1
        style={{
          color: 'white',
          fontSize: '60px',
          fontStyle: 'italic',
          lineHeight: 1,
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          flexWrap: "wrap", // wrap letters if needed on small screens
          justifyContent: "center",
          margin: 0,
        }}
      >
        A
        <span style={{
          color: '#2E9FFF',
          animation: shouldRotate ? 'spin 2s linear 1' : 'none',
          display: 'inline-block',
          margin: '0 2px',
          transformOrigin: 'center center',
        }}>r</span>
        mour
        <span style={{
          color: '#2E9FFF',
          animation: shouldRotate ? 'spin 2s linear 1' : 'none',
          display: 'inline-block',
          margin: '0 2px',
          transformOrigin: 'center center',
        }}>P</span>
        ro
      </h1>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          h1 {
            font-size: 35px !important;
            text-align: center;
          }

          img {
            max-height: 50px !important;
            max-width: 150px !important;
          }
        }

        @media (max-width: 480px) {
          h1 {
            font-size: 25px !important;
          }

          img {
            max-height: 40px !important;
            max-width: 120px !important;
          }
        }
      `}</style>
    </div>
  );
}

export default TopNavbar;
